const icon = require('vue-svgicon');
icon.register({
    'menu-arrow': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M32 4.231L16 27.77 0 4.231z"/>`,
    },
});
